import { z } from 'zod'

export enum VERIFY_OTP_RESULT_STATUS {
  SUCCESS = 'SUCCESS',
  EXPIRED = 'EXPIRED',
  WRONG_CODE = 'WRONG_CODE',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  ALREADY_BOOKED_APPOINTMENT = 'ALREADY_BOOKED_APPOINTMENT'
}

export const verifyOneTimePasswordOutputZ = z.object({
  status: z.enum(Object.values(VERIFY_OTP_RESULT_STATUS) as [string, ...string[]])
})

export type VerifyOneTimePasswordOutput = z.infer<typeof verifyOneTimePasswordOutputZ>
